import type * as React from 'react';
import { css } from '@emotion/react';
import { Skeleton } from '@verclam/ui-kit';
import { theme } from '@Guidelines/Theme/theme';

const skeletonStackStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
`;

const cardsSkeletonGridStyle = css`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(min(20rem, 100%), 1fr));
	gap: 1.25rem;
`;

const DocumentTemplatesSkeleton: React.FC = () => (
	<div css={skeletonStackStyle}>
		<div css={cardsSkeletonGridStyle}>
			<Skeleton height="10rem" borderRadius={theme.radii.xlarge} animation="wave" />
			<Skeleton height="10rem" borderRadius={theme.radii.xlarge} animation="wave" />
			<Skeleton height="10rem" borderRadius={theme.radii.xlarge} animation="wave" />
			<Skeleton height="10rem" borderRadius={theme.radii.xlarge} animation="wave" />
			<Skeleton height="10rem" borderRadius={theme.radii.xlarge} animation="wave" />
		</div>
	</div>
);

export default DocumentTemplatesSkeleton;
